<template>

<div class="emailContainer" :class="['emailContainer', {emailReply: reply}]">

    <div class="emailHeader">
        <div class="emailInitial" :data-letters="authorName ? authorName[0] : ''" :style="random_color"/>
        <!-- <div class="emailProfileImg" :style="profile_img"></div> -->
        <div class="emailTags">
            <div class="emailAccountName">
                {{authorName}}
            </div>
            <div class="emailSentTo">Til: {{sender == 'gamemaster' ? pgroup_name: sent_to}}</div>
        </div>
        <div class="emailTime">
            <div class="emailPostTime">{{post_date}}</div>
            <div class="emailPostTime" style="font-weight: bold">{{post_time}}</div>
        </div>
    </div>

    <div class="emailBody" :style="queued ? 'padding-bottom: 0; margin-bottom: 0; border-bottom: none;' : null">
        <div class="emailBodyText">{{text}}</div>
        <div class="emailDelete" v-if="edit" @click="removePost">
            <i class="fas fa-trash-alt" style="color: #ed5338" />
        </div>
    </div>

    <div class="emailFooter" v-if="!reply && !queued">

        <!-- Email upload -->
        <!-- <div class="emailUpload" v-if="post.attachment && !$parent.gamemaster">
            <div v-if="!post.attachment.file_id && !post.attachment.message_sid">
                <input type="file" accept="video/* image/* audio/*" capture="user" style="display:none" ref="fileUpload"/>
                <div class="uploadText">
                    Denne email skal besvares med en fil upload. Upload herfra eller få tilsendt et link på SMS.
                </div>
                <div class="uploadBtns">
                    <i title="Upload fil" style="margin: 0.4em 1em 0 0.5em;" class="button fas fa-upload" @click="uploadFile"/>
                    <div class="smsButtons">
                        <DropdownCheck :full_width="false" :check_all="false" :multiselect="false" :items="this.getUsers" id_str="user_id" label_str="name" :value="upload_user"/>
                        <i title="Send sms" style="margin: 0.5em 0.5em 0 0.5em" class="button fas fa-comment-dots" @click="sendUploadUrl"/>
                    </div>
                </div>
            </div>
            <div class="emailUpload" v-else-if="post.attachment.message_sid && !post.attachment.file_id">
                <i class="fas fa-ellipsis-h" style="margin: 0 0.5em 0.5em 0.5em; color: rgb(243, 122, 72)"/>
                <div class="uploadText">
                    SMS sendt
                </div>
            </div>
            <div class="emailUpload" v-else-if="post.attachment.file_id">
                <i class="fas fa-check" style="margin: 0 0.5em 0.5em 0.5em; color: rgb(64, 194, 64)"/>
                <div class="uploadText">
                    Fil modtaget
                </div>
            </div>
            <i v-if="post.attachment.file_id || post.attachment.message_sid" title="Reset upload" class="fas fa-undo button"
                @click="resetUpload" style="margin: 0 auto auto 3em; font-size: 0.8em;"/>

        </div> -->

        <!-- Email upload -->
        <!-- <div class="emailUpload" v-else-if="post.attachment && $parent.gamemaster">
            <div class="emailUpload" v-if="!post.attachment.file_id">
                <i class="fas fa-times" style="margin: 0 0.5em 0.5em 0.5em; color: #ed5338"/>
                 <div class="uploadText">
                    Venter på fil...
                </div>
            </div>
            <div class="emailUpload" v-else>
                <i class="fas fa-check" style="margin: 0 0.5em 0.5em 0.5em; color: rgb(64, 194, 64)"/>
                <div class="uploadText">
                    Fil modtaget - <a :href="getFileUrl(post.attachment.file_id)" target="_blank">Se her</a>
                </div>
            </div>
        </div> -->

        <Email v-for="em in replies" :key="em.post_id" :publishTime="em.publish_time_ts"
            :authorName="em.account_name" :authorHandle="em.account_handle" :pgroup_id="em.pgroup_id"
            :verified="em.verified" :imageUrl="em.image_url" :text="em.text" :sent_to="em.sent_to"
            :sender="em.sender" :edit="edit" :post_id="em.post_id" :reply="true" @removePost="removePost" />

        <div class="emailComment">
            <TextareaAutosize ref="commentTextarea" v-model="comment_text" :disabled="disabled" placeholder="Skriv et svar..." rows="1" class="emailCommentText" :class="{participant: !edit, dashboard: edit}" :min-height="24" style="margin-left: 0" />
            <div class="emailCommentSend" @click="sendReply">
                <i title="Send besked" class="fas fa-reply emailCommentSendIcon" />
            </div>
        </div>
    </div>

</div>

</template>

<script>
import Vue from 'vue'
import TextareaAutosize from 'vue-textarea-autosize'
import dayjs from 'dayjs';
import Email from './Email';
import { mapActions, mapGetters, mapState } from 'vuex';
import { uploadAttachment } from '../global/uploadFile';
import axios from 'axios';
Vue.use(TextareaAutosize)

export default {
    name: 'Email',
    components: {
        Email,
    },
    props: {
        post_id: Number,
        parent_post_id: Number,
        authorName: String,
        authorHandle: String,
        verified: Boolean,
        text: String,
        sender: String,
        imageUrl: String,
        publishTime: Number,
        edit: Boolean,
        queued: Boolean,
        reply: Boolean,
        sent_to: String,
        pgroup_id: Number,
        disabled: Boolean
    },
    data(){
        return {
            time_since_publish: '',
            comment_text: '',
            upload_user: []
        }
    },
    computed: {
        ...mapGetters([
            'getPubPosts',
            'getPubPost',
            'getParticipantGroups',
            'getUsers',
            'getFileUrl'
        ]),
        ...mapState([
            'curr_pgroup',
            'curr_instance',
            'curr_project',
            'ICOLORS'
        ]),
        ...mapState({
            gamemaster_id: state => state.gamemaster.gamemaster_id
        }),
        post() { return this.getPubPost(this.post_id) },
        profile_img() { return 'background-image: url(' + (this.imageUrl? this.imageUrl: '/img/facebook-default.jpg') + ');' },
        comment_img() {
            if (this.edit && this.$parent.selected_account) return this.$parent.selected_account.avatar
            return 'background-image: url(/img/facebook-default.jpg);'
        },
        replies() {return this.getPubPosts.filter(p => p.type == 'email' && p.parent_post_id == this.post_id).reverse()},
        reply_empty() {return this.comment_text == ""},
        curr_pgroup_empty() {return Object.keys(this.curr_pgroup).length === 0 && this.curr_pgroup.constructor === Object},
        curr_pgroup_id() {return !this.curr_pgroup_empty? this.curr_pgroup.pgroup_id: null},
        pgroup_name() {
            // Curr pgroup is set on participant view, not on dashboard view
            return !this.curr_pgroup_empty
                ? this.curr_pgroup.name
                // If pgroup_id is set, find name in store, else email must have been sent to all
                : (this.pgroup_id
                    ? this.getParticipantGroups.find(p => p.pgroup_id === this.pgroup_id).name
                    : "Alle")
            },
        post_date() {return dayjs.unix(this.publishTime).format('D MMMM YYYY')},
        post_time() {return dayjs.unix(this.publishTime).format('HH:mm')},
        random_color() {
            const random = Math.floor(Math.random() * this.ICOLORS.length);
            return 'border-radius: 50%; background-color: ' + this.ICOLORS[random] + ';'
        }
    },
    methods: {
        ...mapActions([
            'initParticipant'
        ]),
        sendUploadUrl() {
            axios.post("/api/attachments?sms_upload=true", {
                user_id: this.upload_user[0],
                post_id: this.post_id,
            })
            .then(this.initParticipant)
        },
        resetUpload() {
            axios.post("/api/attachments?reset=true", {
                post_id: this.post_id,
            })
            .then(this.initParticipant)
        },
        uploadFile() {
            const fileUpload = this.$refs.fileUpload
            fileUpload.onchange = () => uploadAttachment(fileUpload.files[0], this.curr_project, this.curr_instance, this.post_id)
            fileUpload.click()
        },
        sendReply() {
            if (this.disabled) return
            let user_meta = null;
            if (this.edit) {
                if (this.sender == 'gamemaster') {
                    user_meta = {
                        name: this.authorName,
                        handle: this.authorHandle,
                        verified: this.verified,
                        image_url: this.imageUrl
                    }
                }
                else {
                    user_meta = {
                        name: this.sent_to,
                        handle: this.sent_to,
                        verified: true,
                        image_url: null
                    }
                }
            }

            const sent_to = (!this.edit && this.sender == 'participant')
                ? this.sent_to
                : (!this.edit && this.sender == 'gamemaster')
                    ? this.authorHandle
                    : null

            if (this.reply_empty) return
            const payload = {
                parent_post_id: this.post_id,
                project_id: this.curr_project,
                instance_id: this.curr_instance,
                gamemaster_id: this.gamemaster_id,
                text: this.comment_text,
                sender: this.edit? 'gamemaster': 'participant',
                account_name: user_meta? user_meta.name: this.pgroup_name,
                account_handle: user_meta? user_meta.handle: this.pgroup_name.replace(' ', '').toLowerCase(),
                sent_to: sent_to,
                image_url: user_meta? user_meta.image_url: null,
                verified: user_meta? user_meta.verified: true,
                pgroup_id: this.edit? this.pgroup_id: this.curr_pgroup_id,
                queued: false,
                type: 'email'
            }
            this.comment_text = ""
            this.$socket.emit('sendPost', payload)
        },
        removePost(post_id=null) {
            isNaN(post_id)? post_id = null: null
            this.$emit('removePost', post_id? post_id: this.post_id)
        },
    }
}
</script>

<style>
.smsButtons {
    justify-content: flex-end;
    display: flex;
    width: 100%;
}

.uploadText {
    font-size: 0.7em;
    margin-bottom: 0.5em;
}

.uploadBtns {
    margin-bottom: 0.5em;
    display: flex;
}

.emailUpload {
    display: flex;
}

.emailContainer {
    font-family: Roboto, Helvetica, Arial, Tahoma, sans-serif;
    background-color: white;
    padding: 1em;
    border-radius: 10px;
    margin-bottom: 0.7em;
}

.emailContainer.emailReply {
    padding: 0 !important;
    border-radius: 0;
}

.emailHeader {
    display: flex;
}

.emailTags {
    margin: auto 0.5em auto 0.5em;
    max-width: 40%;
    word-break: break-all;
}

.emailTime {
    margin-left: auto;
    display: flex;
    flex-direction: column;
}

.emailPostTime {
    margin-top: 0.1em;
    font-size: 0.9em;
    color: #606771;
    margin-left: auto;
    float: right;
    text-align: right;
}

.emailSentTo {
    font-size: 0.9em;
    color: #606771;
}

.emailProfileImg {
    height: 2.4em;
    width: 2.4em;
    border-radius: 20px;
    background-size: contain;
    background-image: url()
}

.emailBody {
    margin-top: 0.8em;
    overflow: hidden;
    overflow-wrap: anywhere;
    padding-bottom: 0.5em;
    margin-bottom: 0.8em;
    border-bottom: 1px solid #bbb;
    display: flex;
}

.emailBodyText {
    white-space: pre-wrap;
}

.emailComment {
    display: flex;
}

.emailCommentImg {
    height: 1.9em;
    width: 1.9em;
    margin-top: auto;
    border-radius: 20px;
    background-size: contain;
}

.emailCommentText {
    margin: auto;
    background-color: #EFF2F5;
    color: #606771;
    padding-top: 0.5em;
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 0;
    border-radius: 20px;
    font-size: 0.9em;
    border: none;
}

.emailCommentText:focus {
    outline: none;
}

.emailCommentText.participant {
    width: 75%;
}

.emailCommentText.dashboard {
    width: 83%;
}

.emailCommentSend {
    height: 1.9em;
    width: 1.9em;
    margin-top: auto;
    border-radius: 20px;
    background-color: #1977F2;
    display: flex;
}

.emailCommentSend:hover {
    cursor: pointer;
}

.emailCommentSendIcon {
    color: white;
    margin: auto;
    margin-right: 0.5em;
}

.emailDelete {
    margin: auto 0 auto auto;
    font-size: 14px;
}

.emailDelete:hover {
    cursor: pointer;
}

</style>